import React, {Component,PureComponent} from 'react';
import {Field, reduxForm} from 'redux-form'
import {Row, Form,Divider} from 'antd';

import {RTLCol,RTLButton} from '../RTLKit';


/* ------ Field -------- */
import TextField from '../formFields/TextField';
import SelectField from '../formFields/SelectField';


/* ------ Validate / Warn  -------- */
import ValidateForm from './parts/addValidate';
import WarnForm from './parts/addWarn';
import Loading from "../loading/loading";

class PosAddEditForm extends Component {
    constructor(props) {
        super(props);

        //---- Detect Add or Edit module
        this.state = {
            mode: 'edit',
            itemId: this.props.match.params.id ? this.props.match.params.id : null, // item id in edit mode
            cities:[],
            formLayout: 'horizontal',
            role:this.props.userValue ? this.props.userValue.rl : null
        };

    }

    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    componentDidMount() {
        this.props.getBankList()
        if (this.props.match.params.id){
            let id = this.props.match.params.id;
            this.props.setUserId(id)
            this.props.getItem(id)
        }
    }

   __getBankList() {
        let bankList = this.props.bankList;
        let dataSource = [];

        if (bankList) {
            for (let i = 0; i < bankList.length; i++) {

                dataSource.push(
                    {label: bankList[i].title, value: bankList[i]._id, key: i}
                );

            }

        }
        return dataSource;
    }

    render() {
        var _self = this;
        const {formLayout} = this.state;

        if(this.props.userInfo) {
            var name = this.props.userInfo.name + ' ' + this.props.userInfo.family
        }

        /*---- set mode ---*/
        if(this.props.initialValues) {
            this.props.initialValues.mode=this.state.mode
        }

        return (
            <Form layout={formLayout} mode={this.state.mode} onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                <Row>
                    <Divider orientation="left">تخصیص دستگاه کارت خوان به {name}</Divider>
                </Row>
                <Row type="flex" justify="start" align="middle">
                    <RTLCol md={18} sm={24} type="flex" justify="start" align="middle" >
                        <Row gutter={16}>

                            <Field
                                name="pos_serial"
                                component={TextField}
                                type="text"
                                label="سریال دستگاه کارتخوان"
                                placeholder="سریال دستگاه کارتخوان"
                                defaultValue={this.props.posInfo && this.props.posInfo.pos_serial ? this.props.posInfo.pos_serial : ''}
                            />
                            <Field
                                name="bank_account"
                                component={SelectField}
                                type="text"
                                label="حساب بانکی"
                                placeholder="حساب بانکی"
                                list={this.__getBankList()}
                                defaultValue={this.props.posInfo && this.props.posInfo.bank_account ? this.props.posInfo.bank_account: ''}
                            />
                        </Row>
                        <Row>
                            <RTLButton loading={this.props.common.isProgressing} type="primary"  shape="round" htmlType="submit" className="login-form-button">
                                {this.state.mode == 'edit' ? "ویرایش" : "ایجاد"}
                            </RTLButton>
                            <RTLButton href="#/user/list" className="backBtn" type="default" shape="round">
                                بازگشت
                            </RTLButton>
                        </Row>
                    </RTLCol>
                </Row>
            </Form>

        );
    }

}

export default PosAddEditForm = reduxForm({
    form: 'editPos',        // <--- a unique name for the form
    validate: ValidateForm, // <--- validation function given to redux-form
    warn: WarnForm
})(PosAddEditForm)
